import React, { useCallback } from 'react';
import { Button, Paper } from "@mui/material";
import { Autorenew, Redo, Save, Undo } from "@mui/icons-material";
import chartingMenuSx from './ChartingMenu.styles';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import { enqueueSnackbar } from 'notistack';
import MenuLayers from './MenuLayers';
import MenuTeeth from './MenuTeeth';
import MenuMarkup from './MenuMarkup';
import MenuDeleteMove from "./MenuDeleteMove";
import MenuExtras from './MenuExtras';
import MenuSymbols from './MenuSymbols';
import AllSymbolsDialog from "./AllSymbolsDialog";
import { useDispatch, useSelector } from "react-redux";
import { actions } from '../Chart.redux';
import useChartAutoSave from 'hooks/useChartAutoSave';



const ChartingMenu = () => {
	const theme = useTheme();
	const sx = chartingMenuSx(theme);
	const dispatch = useDispatch();
	const saving = useSelector(state => state.chart.saving);

	const [ autoSaveEnabled, autoSaveInterval ] = useChartAutoSave();

	const handleToggleAutoSave = useCallback(() => {
		const enabledDisabled = autoSaveEnabled
			? 'disabled'
			: `enabled (saves every ${autoSaveInterval} seconds)`;
		enqueueSnackbar(`Auto-save ${enabledDisabled}.`, {
			variant: autoSaveEnabled
				? 'default'
				: 'success',
			autoHideDuration: autoSaveEnabled
				? 1000
				: 2000,
		});
		dispatch(actions.setState({ autoSaveEnabled: !autoSaveEnabled }));
	}, [ autoSaveEnabled, autoSaveInterval, dispatch ]);

	return (
		<Paper elevation={2} sx={sx.menuContainer}>
			<MenuLayers />
			<MenuTeeth />
			<MenuSymbols />
			<MenuMarkup />
			<MenuExtras />
			<MenuDeleteMove />
			<AllSymbolsDialog />


			<Button
				variant="outlined"
				sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
				onClick={() => dispatch(actions.undoRedo('UNDO'))}
			>
				<Undo />
			</Button>


			<Button
				variant="outlined"
				sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
				onClick={() => dispatch(actions.undoRedo('REDO'))}
			>
				<Redo />
			</Button>


			<Button
				variant="outlined"
				disabled={saving}
				sx={{ ...sx.buttonFloat, ...sx.buttonSmall }}
				onClick={() => dispatch(actions.saveChart())}
			>
				<Save />
			</Button>
			<Button
				sx={{
					...sx.buttonFloat, ...(autoSaveEnabled
						? sx.autoSaveOn
						: sx.autoSaveOff),
				}}
				onClick={handleToggleAutoSave}
			>
				<Autorenew />
			</Button>

		</Paper>
	);
};



export default ChartingMenu;
